import { i18nConfig } from 'es2015-i18n-tag'
import translations from './translation.pt.json'

i18nConfig({
	locales: 'pt',
	group: 'pt',
	number: {
		currency: 'EUR',
	},
	translations,
})
